/** Count visible source events without multiplying optional joins. */
export function promptCount(outputAlias, stepAlias = "p", predicate = undefined) {
    return {
        outputAlias,
        computed: {
            field: { stepAlias, field: "DIMENSION_FIELD_PROMPT_EVENT_ID" },
            op: "AGGREGATE_OP_COUNT_DISTINCT",
            ...(predicate ? { predicate } : {}),
        },
    };
}
